import { removeEmptyValues } from '../../../utils';
import { Company, mapInstitutions } from '../../Institution';
import { Software } from '../domain/software';
import { RSoftware } from '../remote/software';

export const mapSingleSoftware = (rSoftware: RSoftware): Software => {
    const {
        id,
        documentId,
        name,
        description,
        repository_link,
        known_by,
        updatedAt,
        createdAt,
        publishedAt
    } = rSoftware;

    return {
        id,
        documentId,
        name,
        description: description ?? undefined,
        repository_link,
        known_by: known_by ? (mapInstitutions(known_by) as Company[]) : [],
        updatedAt,
        createdAt,
        publishedAt
    };
};

export const mapSoftware = (rSoftware: RSoftware[]): Software[] => {
    const mappedSoftware =
        rSoftware !== null && rSoftware !== undefined
            ? removeEmptyValues(rSoftware.map(mapSingleSoftware))
            : [];

    return mappedSoftware;
};
